import { PharmacistInterface, User } from "@/vuex/auth/types";
import { UserState } from "@/vuex/modules/user/user.types";
import { TablePagination } from "helix-vue-components";
import { MutationTree } from "vuex";

type UserMutationTree = MutationTree<UserState>;

export const mutations: UserMutationTree = {
  setUsers(state: UserState, users: User[]) {
    state.users = users;
  },
  setLoading(state: UserState, loading: boolean) {
    state.loading = loading;
  },
  setPagination(state: UserState, pagination: TablePagination | null) {
    state.pagination = pagination;
  },
  setCurrentUser(state: UserState, user: User | null) {
    state.currentUser = user;
  },
  setPharmacistInfo(state: UserState, pharmacist: PharmacistInterface | null) {
    state.pharmacistInfo = pharmacist;
  },
  setPharmacistInfoFetched(state: UserState, value: boolean) {
    state.pharmacistInfoFetched = value;
  },
  setDisabledMode(state: UserState, disable: boolean) {
    state.disabledMode = disable;
  }
};
